'use client';
import * as bondAction from '@/redux/actions/bondDetails';
import * as bonds from '@/redux/actions/bonds';
import * as commonAction from '@/redux/actions/common';
import * as dashboardAction from '@/redux/actions/dashboard';
import { Bond } from '@/services/interface/bonds';
import { makeNavigationSiteAnalytics } from '@/services/simpleApis';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { memo, useEffect, useMemo, useRef } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

interface ScreenerBondsNavigationProps {
    bondId: string;
    isBondsHeaderDetailLoader: boolean | undefined;
    bondsData: any;
}

const ScreenerBondsNavigation = ({ bondId, isBondsHeaderDetailLoader, bondsData }: ScreenerBondsNavigationProps) => {
    const fromPage = 'screener';

    const isFromScreenerPage = fromPage === 'screener';

    const isinList = useMemo(() => (isFromScreenerPage ? bondsData?.bonds?.map((bond: Bond) => bond.isin) : []), [bondsData?.bonds]);

    console.log('bondsData', bondsData);

    const currentBondIndex = useMemo(
        () => (isFromScreenerPage && isinList ? isinList.findIndex((isin: string) => isin === bondId) : null),
        [isinList, bondId]
    );

    const prevBondIsin = useMemo(
        () => (!!isinList?.length && (!!currentBondIndex || currentBondIndex == 0) ? isinList[currentBondIndex - 1] : null),
        [isinList, currentBondIndex]
    );
    const prevBondLink = useMemo(() => (isinList ? `/bonds/${prevBondIsin}?from=${fromPage}` : ''), [prevBondIsin, isinList]);

    const nextBondIsin = useMemo(
        () => (!!isinList?.length && (!!currentBondIndex || currentBondIndex == 0) ? isinList[currentBondIndex + 1] : null),
        [isinList, currentBondIndex]
    );
    const nextBondLink = useMemo(() => (isinList ? `/bonds/${nextBondIsin}?from=${fromPage}` : ''), [nextBondIsin, isinList]);

    const router = useRouter();
    const timer = useRef<NodeJS.Timeout>(null);
    const handleNavigatePrevNextBond = (e: KeyboardEvent) => {
        const keyPressed = e.keyCode;
        if (timer.current) clearTimeout(timer.current);

        const isKeyBoardInFocus = document.querySelector(':focus');
        if (isKeyBoardInFocus) return;

        const newTimer = setTimeout(() => {
            //left arrow
            if (keyPressed === 37 && prevBondIsin && prevBondLink) {
                makeNavigationSiteAnalytics('Bond name', `/bonds`, `${prevBondIsin}`);
                router.push(prevBondLink);

                //right arrow
            } else if (keyPressed === 39 && nextBondIsin && nextBondLink) {
                router.push(nextBondLink);
                makeNavigationSiteAnalytics('Bond name', `/bonds`, `${nextBondIsin}`);
            }
        }, 500);
        timer.current = newTimer;
    };

    useEffect(() => {
        window.addEventListener('keydown', handleNavigatePrevNextBond);
        return () => {
            window.removeEventListener('keydown', handleNavigatePrevNextBond);
        };
    }, [bondId]);
    return (
        <div className={`col-6 col-lg-3 d-flex p-0 align-items-center justify-content-center`}>
            {!!currentBondIndex && currentBondIndex > 0 ? (
                <Link
                    href={prevBondLink}
                    prefetch
                    onClick={() => void makeNavigationSiteAnalytics('Prev button', `/bonds`, prevBondIsin || '')}
                    className={`rounded-3 p-1 btn text-primary text-nowrap prevBond ${
                        isBondsHeaderDetailLoader ? 'pe-none opacity-50' : ''
                    }`}
                    style={{ height: 'max-content', fontSize: 13 }}
                    title="Visit previous bond's detail from the screener result."
                >
                    ⇦ Prev
                </Link>
            ) : (
                <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
            )}
            <span className="text-secondary fw-semibold text-nowrap">
                {(!!currentBondIndex || currentBondIndex === 0) && currentBondIndex + 1 + ' of ' + isinList?.length}
            </span>
            {(!!currentBondIndex || currentBondIndex === 0) && currentBondIndex < isinList.length - 1 ? (
                <Link
                    href={nextBondLink}
                    prefetch
                    onClick={() => void makeNavigationSiteAnalytics('Next button', `/bonds`, nextBondIsin || '')}
                    className={`rounded-3 p-1 btn text-primary text-nowrap nextBond ${
                        isBondsHeaderDetailLoader ? 'pe-none opacity-50' : ''
                    }`}
                    style={{ height: 'max-content', fontSize: 13 }}
                    title="Visit next bond's detail from the screener result."
                >
                    Next ⇨
                </Link>
            ) : (
                <span>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</span>
            )}
        </div>
    );
};

const mapStatesToProps = ({
    bondsDetail: {
        bondsHeaderDetail = [],
        bondsDetailData,
        isBondsDetailDataLoader = false,
        isBondsHeaderDetailLoader = false,
        isSameIssuerBondsLoader = false,
        sameIssuerBondsData = {},
    },
    dashboard: {
        bondPriceChartsData = [],
        isbondPriceChartsDataLoader = false,
        bondsDetailTokenData = {},
        isBondsDetailTokenLoader = false,
    },
    bonds: { bondsData = {}, followBond = {}, isFollowBondLoader = false },
    common: { dataUploadStatusData = { data: undefined } },
}: any) => {
    return {
        bondsHeaderDetail,
        isBondsHeaderDetailLoader,
        bondPriceChartsData,
        isbondPriceChartsDataLoader,
        bondsDetailData,
        isBondsDetailDataLoader,
        bondsData,
        followBond,
        isFollowBondLoader,
        isBondsDetailTokenLoader,
        bondsDetailTokenData,
        dataUploadStatusData,
        isSameIssuerBondsLoader,
        sameIssuerBondsData,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators(
        {
            ...bonds,
            ...bondAction,
            ...dashboardAction,
            ...commonAction,
        },
        dispatch
    );
};

export default memo(connect(mapStatesToProps, mapDispatchToProps)(ScreenerBondsNavigation));
